
<style scoped lang="scss">
li {
  list-style: none;
}
.nav_box {
  position: fixed;
  left: 0;
  height: 100%;
  background: #fff;
  width: 210px;
  ul {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  li.title {
    background: #f9f9f9;
    color: #999999;
    padding-left: 50px;
  }
  li {
    box-sizing: border-box;
    padding-left: 60px;
    height: 50px;
    line-height: 50px;
    text-align: left;
    color: #666666;
    cursor: pointer;
  }
  li.c:hover {
    background: #f0f6ff;
  }
  li.li_active {
    background: #f0f6ff;
    border-right: 3px solid #3399ff;
    color:#409eff;
  }
}
</style>
<template>
  <div class="nav_box">
    <ul>
      <li
          v-for="(item, index) in nav"
          :key="index"
          :class="item.type == 'title'?'title' : item.active ? 'c li_active' : 'c'"
          @click="handleClick(item)"
      >
        {{ item.chName }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "系统管理",
      nav: [
        {
            name: "组织机构",
            active: true,
            path: "/systemManage/organizationManage",
          },
        {
            name: "角色管理",
            path: "/systemManage/roleManage",
          },
        {
            name: "用户组管理",
            path: "/systemManage/ruserGroupManage",
          },
        {
          name: "用户管理",
          path: "/systemManage/userManage",
        },
        {
            name: "接口管理",
            path: "/systemManage/apiManage",
          },
        {
            name: "公告管理",
            path: "/systemManage/noticeManage",
          },
        {
            name: "日志管理",
            path: "/systemManage/logManage",
          },
        {
            name: "登录规则管理",
            path: "/systemManage/loginRuleManage",
          },
        {
            name: "密码规则管理",
            path: "/systemManage/passwordManage",
          },
        {
            name: "黑名单管理",
            path: "/systemManage/blackManage",
          },
        {
            name: "白名单管理",
            path: "/systemManage/whiteManage",
          },
        {
            name: "用户IP管理",
            path: "/systemManage/ruserIpManage",
          },
        {
            name: "功能管理",
            path: "/systemManage/functionManage",
          },
      ],
    };
  },
  methods: {
    handleClick(item) {
      let tempIndex = this.nav.indexOf(item);
      this.nav = this.nav.map((item) => {
        item.active = false;
        return item;
      });
      this.nav[tempIndex].active = true;
      this.$router.push(item.url);
    },
  },
  mounted() {
    // let menus = this.$store.state.user.menus.data;
    let menus = JSON.parse(localStorage.getItem('USER_MENU_LIST'))
    let menu = menus.filter((item) => {
      if (item.enName == "xtgl") return item;
    })[0];
    this.nav = menu.children;
    let tempPath = this.$route.path;
    let tempObj = this.nav.filter((item) => {
      if (item.url == tempPath) return item;
    })[0];
    let tempIndex = this.nav.indexOf(tempObj);
    this.nav = this.nav.map((item) => {
      item.active = false;
      return item;
    });
    this.nav[tempIndex].active = true;
  }
};
</script>

